import React from "react";
import { Link } from "gatsby";
import WidgetContainer from "../WidgetContainer/WidgetContainer";

import DownloadNow from "../../images/footer/download-now.svg";
import FBLogo from "../../images/footer/facebook-icon.svg";
import LiLogo from "../../images/footer/linkedin-icon.svg";
import TwLogo from "../../images/footer/twitter-icon.svg";
import PhonePeLogo from "../../images/footer/ppl.svg";
import SisaImg from "../../images/footer/sisa.png";
import GTADownloadIcon from "../../images/footer/gettheappdlicon.svg";
import "./Footer.css";

const Footer = props => (
    <>
        <WidgetContainer>
            <footer className="ft-main">
                <div className="ft-main__item">
                    <p>
                        <img
                            src={PhonePeLogo}
                            width="120"
                            alt="PhonePe Logo"
                            id="ppl"
                        />
                    </p>
                </div>
                <div className="ft-main__item ft-main__item__hide"></div>
                <div className="ft-main__break-item"></div>
                <div className="ft-main__item" id="gn">
                    <h3 className="ft-main__item__title">General</h3>
                    <ul>
                        <li>
                            <Link to="/about-us/" activeClassName="active">
                                About Us
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/business-solutions/"
                                activeClassName="active"
                            >
                                Business Solutions
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/report-vulnerability/"
                                activeClassName="active"
                            >
                                Report Vulnerability
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/merchant-partners/"
                                activeClassName="active"
                            >
                                Merchant Partners
                            </Link>
                        </li>
                    </ul>
                    <div className="ft-copyright ft-copyright-desktop">
                        &copy; 2020, All rights reserved
                    </div>
                </div>

                <div className="ft-main__item">
                    <h3 className="ft-main__item__title">Connect</h3>
                    <ul>
                        <li>
                            <a href="https://careers.phonepe.com/">Careers</a>
                        </li>
                        <li>
                            <Link to="/contact-us/" activeClassName="active">
                                Contact us
                            </Link>
                        </li>
                        <li>
                            <a
                                href="https://www.phonepeethics.com/content/phonepe-ethics/en_us.html"
                                target="_blank"
                            >
                                Ethics
                            </a>
                        </li>
                        <li>
                            <a href="https://blog.phonepe.com/" target="_blank">
                                Blog
                            </a>
                        </li>
                    </ul>
                </div>
                <div className="ft-main__item ft-main__break-item"></div>

                <div className="ft-main__item" id="legal">
                    <h3 className="ft-main__item__title">Legal</h3>
                    <ul>
                        <li>
                            <Link
                                to="/terms-conditions/"
                                activeClassName="active"
                            >
                                Terms &amp; Conditions
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/privacy-policy/"
                                activeClassName="active"
                            >
                                Policy
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/how-to-pay/pay-by-phonepe/web/"
                                activeClassName="active"
                            >
                                How to Pay
                            </Link>
                        </li>
                        <li>
                            <Link to="/ewaste-policy/" activeClassName="active">
                                E-Waste Policy
                            </Link>
                        </li>
                    </ul>
                </div>
                <div className="ft-main__item" id="cert-section">
                    <h3 className="ft-main__item__title">Certification</h3>
                    <ul id="sisaimg-container">
                        <li>
                            <a
                                href="https://www.sisainfosec.com/certificate.php?number=47255411641632600903&type=pcidss"
                                target="_blank"
                            >
                                <img
                                    src={SisaImg}
                                    height="71"
                                    width="113"
                                    alt="Sisa Logo"
                                />
                            </a>
                        </li>
                    </ul>
                </div>
                <div className="ft-main__item ft-main__break-item"></div>

                <div className="ft-main__item" id="saa">
                    <h3 className="ft-main__item__title">See All Apps</h3>
                    <ul className="download-now-btn-container">
                        <li>
                            <Link to="/app-download/">
                                <img
                                    src={DownloadNow}
                                    alt="Download PhonePe App Button Icon"
                                />
                            </Link>
                        </li>
                    </ul>
                    <div>
                        <ul className="ft-main__item__icon-container ft-main__item__media-icon-container">
                            <li>
                                <a
                                    href="https://www.linkedin.com/company/phonepe-internet"
                                    target="_blank"
                                >
                                    <img src={LiLogo} alt="LinkedIn Logo" />
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://twitter.com/PhonePe_"
                                    target="_blank"
                                >
                                    <img src={TwLogo} alt="Twitter Logo" />
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://www.facebook.com/OfficialPhonePe/"
                                    target="_blank"
                                >
                                    <img src={FBLogo} alt="Fb Logo" />
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="ft-main__item ft-main__break-item"></div>

                {props.showFLButton ? (
                    <div className="t-main__item floating-btn">
                        <a href="https://phon.pe/installPPIconWeb">
                            <span>
                                <img src={GTADownloadIcon} alt="" width="20" />
                            </span>
                            <span>Get the app</span>
                        </a>
                    </div>
                ) : null}
            </footer>
            <div className="ft-copyright ft-copyright-mobile">
                &copy; 2020, All rights reserved
            </div>
        </WidgetContainer>
    </>
);

export default Footer;
